module.exports = "/images/contact-us-phone-icon.svg?08dbd43089bb5f0f9dae8909ba54cf96";